// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"63dabb54","314":"61c3d445","500":"42b51117"}[chunkId] + ".chunk.css";
};